module.exports = __webpack_public_path__ + "static/media/dont2.bbe82e23.png";